// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BBgZxL3moH {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.BBgZxL3moH h4 {
  line-height: 3em;
}
.BBgZxL3moH .HyehwUqytV {
  float: left;
  width: 100%;
}
.BBgZxL3moH .OCYgA0ytim {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.BBgZxL3moH .OCYgA0ytim:hover {
  cursor: pointer;
}
.BBgZxL3moH .OCYgA0ytim:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.npOEcZaFh0 .Q_3QYpe7ua:focus {
  outline: none;
}
.npOEcZaFh0 .Q_3QYpe7ua.SbIsHJhc5p.jNGxSCCQcS {
  background: #375A88;
}
.npOEcZaFh0 .Q_3QYpe7ua.SbIsHJhc5p.jNGxSCCQcS span {
  color: #fff;
}
.npOEcZaFh0 .jNGxSCCQcS {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.npOEcZaFh0 .jNGxSCCQcS:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.npOEcZaFh0 input {
  height: 38px;
  min-width: 220px;
}
.OCYgA0ytim.xEMFQMfFol {
  background: #410102;
}
.OCYgA0ytim.WAt1tPRk6f {
  background: #911318;
}
.OCYgA0ytim.ZNwAa0MpEf {
  background: #D8293B;
}
.OCYgA0ytim.ajUsfv4Lui {
  background: #F2373C;
}
.OCYgA0ytim.QmZWep9aXo {
  background: #FC4448;
}
.OCYgA0ytim.jqN7_ZX5Vz {
  background: #ED535E;
}
.OCYgA0ytim.lwVL5qyy25 {
  background: #E34926;
}
.OCYgA0ytim.uIRfjGc_W9 {
  background: #FC562B;
}
.OCYgA0ytim.J5pWqFIgvR {
  background: #FC6722;
}
.OCYgA0ytim.PnaiCIf1e5 {
  background: #FD7F24;
}
.OCYgA0ytim.Up5XPvr0HX {
  background: #FD8D26;
}
.OCYgA0ytim.JedIt3_2g_ {
  background: #EC9C3E;
}
.OCYgA0ytim.KvBACyOP4L {
  background: #0e673a;
}
.OCYgA0ytim.bCpr6OydxW {
  background: #208740;
}
.OCYgA0ytim.f_fRpuX4LS {
  background: #239718;
}
.OCYgA0ytim.Pwr5Bi1CSa {
  background: #55A84D;
}
.OCYgA0ytim.Rs9XTaQp_o {
  background: #4BBE5A;
}
.OCYgA0ytim.LJvMUseXH2 {
  background: #0CCA6A;
}
.OCYgA0ytim.qX04fsdjIw {
  background: #0A3C64;
}
.OCYgA0ytim.tUjEw_JCCj {
  background: #0d487a;
}
.OCYgA0ytim.jrISaA6VAz {
  background: #10538d;
}
.OCYgA0ytim.c6ZSqRwxvC {
  background: #115A99;
}
.OCYgA0ytim.Ge2sWlWpQV {
  background: #3387E2;
}
.OCYgA0ytim.lD08JaC4IX {
  background: #1BA9CF;
}
.OCYgA0ytim.JMM98h99Yb {
  background: #d27c02;
}
.OCYgA0ytim.Fna4FYl30i {
  background: #fb9402;
}
.OCYgA0ytim.LxdczX4nxm {
  background: #FD9B30;
}
.OCYgA0ytim.EXREqdqdbv {
  background: #FDBE2D;
}
.OCYgA0ytim.yEL5T4GEiI {
  background: #FED831;
}
.OCYgA0ytim.tF_5WSbEDL {
  background: #FFFD38;
}
.OCYgA0ytim.NnkBqmzvya {
  background: #2D215C;
}
.OCYgA0ytim.IBk6p9LhM0 {
  background: #483C83;
}
.OCYgA0ytim.O4DXm69yR4 {
  background: #58518d;
}
.OCYgA0ytim.kIjzDOaYCe {
  background: #7068A9;
}
.OCYgA0ytim.Zkyci4Khwv {
  background: #7f78b2;
}
.OCYgA0ytim.MN5lHmNTMB {
  background: #8f88bc;
}
.OCYgA0ytim.GY9EiMZ2uz {
  background: #000;
}
.OCYgA0ytim.DymuPvysUa {
  background: #282626;
}
.OCYgA0ytim.N88zLb_dCd {
  background: #242222;
}
.OCYgA0ytim.L2Mkpf3IMn {
  background: #353838;
}
.OCYgA0ytim.FmZuIben9K {
  background: #666;
}
.OCYgA0ytim.I4p3zxgsdB {
  background: #999;
}
.eX_j2xv4ql {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.eX_j2xv4ql .vFJ1hcHAv_ {
  display: none;
}
.tRP4NkET6W {
  justify-content: center;
  border-top: none;
  padding: 0 20px 50px 20px;
}
.m9RlzbkT4Z {
  font-weight: 400;
}
.TNJR7LLxvn {
  padding: 40px 50px;
  font-size: 16px;
  text-align: center;
}
.TNJR7LLxvn > p {
  margin-bottom: 0;
  padding: 8px 8px 0 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `BBgZxL3moH`,
	"color-row": `HyehwUqytV`,
	"color-tile": `OCYgA0ytim`,
	"picker-component": `npOEcZaFh0`,
	"picker-element": `Q_3QYpe7ua`,
	"active": `SbIsHJhc5p`,
	"btn": `jNGxSCCQcS`,
	"red-1": `xEMFQMfFol`,
	"red-2": `WAt1tPRk6f`,
	"red-3": `ZNwAa0MpEf`,
	"red-4": `ajUsfv4Lui`,
	"red-5": `QmZWep9aXo`,
	"red-6": `jqN7_ZX5Vz`,
	"orange-1": `lwVL5qyy25`,
	"orange-2": `uIRfjGc_W9`,
	"orange-3": `J5pWqFIgvR`,
	"orange-4": `PnaiCIf1e5`,
	"orange-5": `Up5XPvr0HX`,
	"orange-6": `JedIt3_2g_`,
	"green-1": `KvBACyOP4L`,
	"green-2": `bCpr6OydxW`,
	"green-3": `f_fRpuX4LS`,
	"green-4": `Pwr5Bi1CSa`,
	"green-5": `Rs9XTaQp_o`,
	"green-6": `LJvMUseXH2`,
	"blue-1": `qX04fsdjIw`,
	"blue-2": `tUjEw_JCCj`,
	"blue-3": `jrISaA6VAz`,
	"blue-4": `c6ZSqRwxvC`,
	"blue-5": `Ge2sWlWpQV`,
	"blue-6": `lD08JaC4IX`,
	"yellow-1": `JMM98h99Yb`,
	"yellow-2": `Fna4FYl30i`,
	"yellow-3": `LxdczX4nxm`,
	"yellow-4": `EXREqdqdbv`,
	"yellow-5": `yEL5T4GEiI`,
	"yellow-6": `tF_5WSbEDL`,
	"purple-1": `NnkBqmzvya`,
	"purple-2": `IBk6p9LhM0`,
	"purple-3": `O4DXm69yR4`,
	"purple-4": `kIjzDOaYCe`,
	"purple-5": `Zkyci4Khwv`,
	"purple-6": `MN5lHmNTMB`,
	"black-1": `GY9EiMZ2uz`,
	"black-2": `DymuPvysUa`,
	"black-3": `N88zLb_dCd`,
	"black-4": `L2Mkpf3IMn`,
	"black-5": `FmZuIben9K`,
	"black-6": `I4p3zxgsdB`,
	"picker-theme": `eX_j2xv4ql`,
	"arrow-regular": `vFJ1hcHAv_`,
	"apply-template-footer": `tRP4NkET6W`,
	"apply-template-footer__cancelBtn": `m9RlzbkT4Z`,
	"apply-template-body": `TNJR7LLxvn`
};
export default ___CSS_LOADER_EXPORT___;
